// @flow
const PAGINATION = {
  PREV_PAGE: ' → السابق',
  NEXT_PAGE: 'التالي ← '
};

export default PAGINATION;
